import { ref } from 'vue'
import type {
	DetailProductPayload,
	GetDetailProductResponse,
} from './pcsServiceTypes'
import pcsService from './usePriceComparison'

export const useGetDetailProduct = () => {
	const isLoading = ref(false)
	const product = ref<GetDetailProductResponse | null>(null)
	const currentPage = ref(1)
	const isShowMore = ref(false)

	const updateState = (data: GetDetailProductResponse, page: number) => {
		if (page === 1) {
			product.value = data
		} else {
			product.value?.products?.push(...data.products)
		}
		isShowMore.value = data.meta.has_next_page
		currentPage.value = page
	}

	const getProductData = async ({
		sku = '',
		location = '',
		display_currency = 'HKD',
		page = 1,
	}: Partial<DetailProductPayload>) => {
		try {
			isLoading.value = true
			const payload = { sku, display_currency, page, location }
			const data = await pcsService.getDetailProduct(payload)
			updateState(data, page)
		} catch (error) {
			console.error(error)
		} finally {
			isLoading.value = false
		}
	}

	const loadMoreData = async ({
		sku,
		location = '',
		display_currency = 'HKD',
	}: Partial<DetailProductPayload>) => {
		if (isShowMore.value) {
			await getProductData({
				sku,
				location,
				display_currency,
				page: currentPage.value + 1,
			})
		}
	}

	return {
		isLoading,
		product,
		getProductData,
		loadMoreData,
		isShowMore,
	}
}
